/* eslint-disable react/no-set-state */
import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import './popupBlockerNotification.scss';

const popupBlockerNotification = ({ onClose }) => (
  <div className='popup-blocker-notification-wrapper'>
    <div className='popup-blocker-notification'>
      <div className='icon-wrapper'>
        <i className='fa fa-frown-o' />
      </div>
      <div className='middle-section'>
        <div className='title'>Notification</div>
        <div className='content'>
          Please disable Pop-up blocker in your browse settings to view PDFs.
          For iPhones, go to Settings, Safari and turn off switch for Block
          Pop-ups
        </div>
      </div>
      <div className='close-wrapper'>
        <IconButton aria-label='Close' onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
    </div>
  </div>
);

popupBlockerNotification.propTypes = {
  onClose: PropTypes.func.isRequired
};

export default popupBlockerNotification;
